/**
 * SILICON SURPLUS - Global JavaScript
 */

document.addEventListener('DOMContentLoaded', function() {

  // Mobile Menu Toggle
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function() {
      mobileMenu.classList.toggle('is-active');
      document.body.classList.toggle('menu-open');
    });
  }

  // Search Toggle
  const searchToggle = document.querySelector('[data-search-toggle]');
  const searchOverlay = document.querySelector('[data-search-overlay]');
  const searchClose = document.querySelector('[data-search-close]');

  if (searchToggle && searchOverlay) {
    searchToggle.addEventListener('click', function() {
      searchOverlay.classList.add('is-active');
      searchOverlay.querySelector('input').focus();
    });
  }

  if (searchClose && searchOverlay) {
    searchClose.addEventListener('click', function() {
      searchOverlay.classList.remove('is-active');
    });

    // Close on escape
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && searchOverlay.classList.contains('is-active')) {
        searchOverlay.classList.remove('is-active');
      }
    });
  }

  // Sticky Header
  const header = document.querySelector('[data-header]');
  let lastScroll = 0;

  if (header) {
    window.addEventListener('scroll', function() {
      const currentScroll = window.pageYOffset;

      if (currentScroll > 100) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }

      lastScroll = currentScroll;
    });
  }

  // Animate on Scroll
  const animatedElements = document.querySelectorAll('.animate-on-scroll');

  if (animatedElements.length > 0) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
        }
      });
    }, { threshold: 0.1 });

    animatedElements.forEach(el => observer.observe(el));
  }

  // Add to Cart Animation
  document.querySelectorAll('form[action="/cart/add"]').forEach(form => {
    form.addEventListener('submit', function(e) {
      const btn = this.querySelector('button[type="submit"]');
      if (btn) {
        btn.classList.add('loading');
      }
    });
  });

  // Cart Count Update (for AJAX add to cart)
  window.updateCartCount = function(count) {
    const cartCountEl = document.querySelector('[data-cart-count]');
    if (cartCountEl) {
      cartCountEl.textContent = count;
      cartCountEl.classList.add('cart-bounce');
      setTimeout(() => cartCountEl.classList.remove('cart-bounce'), 500);
    }
  };

  // Quick Add to Cart
  document.querySelectorAll('.product-card form').forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      
      const formData = new FormData(this);
      
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        // Update cart count
        fetch('/cart.js')
          .then(res => res.json())
          .then(cart => {
            window.updateCartCount(cart.item_count);
          });
        
        // Show success feedback
        const btn = this.querySelector('button');
        if (btn) {
          const originalText = btn.textContent;
          btn.textContent = 'Added!';
          btn.classList.add('glow');
          setTimeout(() => {
            btn.textContent = originalText;
            btn.classList.remove('glow');
          }, 1500);
        }
      })
      .catch(error => {
        console.error('Error:', error);
      });
    });
  });

  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });

  // Lazy Image Loading
  document.querySelectorAll('img[loading="lazy"]').forEach(img => {
    if (img.complete) {
      img.classList.add('loaded');
    } else {
      img.addEventListener('load', () => img.classList.add('loaded'));
    }
  });

  // Close mobile menu when clicking outside
  document.addEventListener('click', function(e) {
    const mobileMenu = document.querySelector('[data-mobile-menu]');
    const menuToggle = document.querySelector('[data-menu-toggle]');
    
    if (mobileMenu && mobileMenu.classList.contains('is-active')) {
      if (!mobileMenu.contains(e.target) && !menuToggle.contains(e.target)) {
        mobileMenu.classList.remove('is-active');
        document.body.classList.remove('menu-open');
      }
    }
  });

  // Localization / currency selector
  const localizationToggle = document.querySelector('[data-localization-toggle]');
  const localizationDropdown = document.querySelector('[data-localization-dropdown]');

  if (localizationToggle && localizationDropdown) {
    localizationToggle.addEventListener('click', function(e) {
      e.stopPropagation();
      const isOpen = localizationDropdown.classList.contains('is-open');
      localizationDropdown.classList.toggle('is-open', !isOpen);
      this.setAttribute('aria-expanded', !isOpen);
    });

    document.addEventListener('click', function(e) {
      if (!localizationToggle.contains(e.target)) {
        localizationDropdown.classList.remove('is-open');
        localizationToggle.setAttribute('aria-expanded', 'false');
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        localizationDropdown.classList.remove('is-open');
        localizationToggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  // Form validation styling
  document.querySelectorAll('form').forEach(form => {
    form.addEventListener('submit', function(e) {
      const invalidInputs = this.querySelectorAll(':invalid');
      invalidInputs.forEach(input => {
        input.classList.add('error');
        input.addEventListener('input', () => input.classList.remove('error'), { once: true });
      });
    });
  });

});
